/** @jsx jsx */

import React, { ReactElement } from 'react';
import { jsx, css } from '@emotion/core';

import PreloadPage from 'app/developer-v3/components/PreloadPage';
import ErrorPage from 'app/developer-v3/components/ErrorPage';

import type { AppSummary } from 'app/developer-v3/types';

const Styles = {
  root: css`
    flex: 1;
    max-width: 1600px;
  `,
};

type Props = {
  appHasLoaded: boolean;
  appSummary?: AppSummary;
  children: ReactElement;
  params: { id?: string };
  hasFailure: boolean;
};

const MainContent = (props: Props) => {
  return (
    <div css={Styles.root}>
      {props.hasFailure ? (
        <ErrorPage />
      ) : !props.params.id || props.appHasLoaded ? (
        React.cloneElement(React.Children.only(props.children), {
          appSummary: props.appSummary,
        })
      ) : (
        <PreloadPage />
      )}
    </div>
  );
};

export default MainContent;
